import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { InadimplenciaHistoricalOverview } from '@/features/inadimplencia/types/InadimplenciaHistoricalOverview.ts';

async function getInadimplenciaKpis(params): Promise<InadimplenciaHistoricalOverview> {
  const api = await getApi();
  const { data } = await api.get<InadimplenciaHistoricalOverview>('/inadimplencia/', {params});
  return data;
}

type QueryFnType = typeof getInadimplenciaKpis;

function useInadimplenciaKpis(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-inadimplencia-historical_overvieww', params],
    queryFn: () =>  getInadimplenciaKpis(params),
  });
}

export { useInadimplenciaKpis };
